export default __webpack_public_path__ + "static/gilroy-semibold-43122bb57d6fdba2d9ce79d6e19eb400.ttf";